(() => {
  const sourceTag = 'iid-sites-migration';
  const initialize = (root = document) => {
    root.querySelectorAll('[data-iid-search-form]').forEach((form) => {
      if (form.dataset.iidSearchReady) return;
      form.dataset.iidSearchReady = 'true';
      const input = form.querySelector('input[name="q"]');
      if (!input) return;
      form.addEventListener('formdata', (event) => {
        event.formData.set('q', input.value.trim());
        event.formData.set('type', 'product');
        event.formData.set('filter.p.tag', sourceTag);
      });
    });
    root.querySelectorAll('[data-iid-search-results]').forEach((results) => {
      const currentUrl = new URL(window.location.href);
      const resetPage = results.dataset.iidSearchCurated === 'true' && currentUrl.searchParams.has('page');
      if ((results.dataset.iidSearchLegacy !== 'true' && !resetPage) || results.dataset.iidSearchPerformed !== 'true') return;
      const input = results.querySelector('input[name="q"]');
      if (!input) return;
      const url = new URL(window.location.href);
      url.searchParams.set('q', input.value.trim());
      url.searchParams.set('type', 'product');
      url.searchParams.set('filter.p.tag', sourceTag);
      url.searchParams.delete('page');
      if (url.href !== window.location.href) window.location.replace(url.href);
    });
    root.querySelectorAll('[data-iid-quantity]').forEach((control) => {
      if (control.dataset.iidReady) return;
      control.dataset.iidReady = 'true';
      const input = control.querySelector('input');
      const decrease = control.querySelector('[data-iid-decrease]');
      const increase = control.querySelector('[data-iid-increase]');
      if (!input || !decrease || !increase) return;
      decrease.hidden = false;
      increase.hidden = false;
      const refresh = () => {
        const value = input.valueAsNumber;
        const min = Number(input.min || 0);
        const max = input.max === '' ? Infinity : Number(input.max);
        decrease.disabled = input.disabled || !Number.isFinite(value) || value <= min;
        increase.disabled = input.disabled || !Number.isFinite(value) || value >= max;
      };
      decrease.addEventListener('click', () => {
        input.stepDown();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      increase.addEventListener('click', () => {
        input.stepUp();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      input.addEventListener('input', refresh);
      input.addEventListener('change', refresh);
      control.addEventListener('iid:quantity-limits', refresh);
      refresh();
    });
    root.querySelectorAll('[data-iid-product][data-iid-variant-limit]').forEach((section) => {
      const form = section.querySelector('.iid-product-form');
      const quantity = form?.querySelector('input[name="quantity"]');
      const submit = form?.querySelector('button[name="add"]');
      const error = section.querySelector('[data-iid-order-limit-error]');
      if (!form || !quantity || !submit || !error || form.dataset.iidOrderLimitReady) return;
      form.dataset.iidOrderLimitReady = 'true';
      let checking = false;
      let approved = false;
      const clearQuantityError = () => {
        quantity.setCustomValidity('');
        error.hidden = true;
      };
      quantity.addEventListener('input', clearQuantityError);
      quantity.addEventListener('change', clearQuantityError);
      form.addEventListener('submit', async (event) => {
        if (approved) {
          approved = false;
          return;
        }
        event.preventDefault();
        if (checking || !form.reportValidity()) return;
        checking = true;
        submit.disabled = true;
        error.hidden = true;
        let blocked = false;
        try {
          const response = await fetch(section.dataset.iidCartDataUrl, {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) throw new Error('Cart check failed');
          const cart = await response.json();
          if (!Array.isArray(cart.items)) throw new Error('Invalid cart');
          const current = cart.items.reduce((total, item) => (
            String(item.variant_id) === String(form.querySelector('input[name="id"]').value) ? total + item.quantity : total
          ), 0);
          const capacity = Math.min(Number(section.dataset.iidVariantLimit), Number(section.dataset.iidVariantCapacity));
          const remaining = Math.max(0, capacity - current);
          quantity.max = String(remaining);
          if (quantity.valueAsNumber > remaining) {
            quantity.setCustomValidity(section.dataset.iidOrderLimitMessage);
            error.textContent = section.dataset.iidOrderLimitMessage;
            error.hidden = false;
            quantity.closest('[data-iid-quantity]').dispatchEvent(new Event('iid:quantity-limits'));
            quantity.reportValidity();
            blocked = remaining === 0;
          } else {
            approved = true;
            submit.disabled = false;
            form.requestSubmit(submit);
          }
        } catch {
          error.textContent = section.dataset.iidCartCheckFailed;
          error.hidden = false;
        } finally {
          checking = false;
          submit.disabled = blocked;
        }
      });
    });
    root.querySelectorAll('.iid-cart-form[data-iid-variant-limit]').forEach((form) => {
      if (form.dataset.iidOrderLimitReady) return;
      form.dataset.iidOrderLimitReady = 'true';
      const quantities = Array.from(form.querySelectorAll('input[data-iid-line-variant]'));
      const checkout = form.querySelector('button[name="checkout"]');
      const warning = form.querySelector('[data-iid-cart-order-limit]');
      const updateLimits = () => {
        const variantTotals = new Map();
        for (const input of quantities) {
          const value = Math.max(0, input.valueAsNumber || 0);
          variantTotals.set(input.dataset.iidLineVariant, (variantTotals.get(input.dataset.iidLineVariant) || 0) + value);
        }
        const limit = Number(form.dataset.iidVariantLimit);
        const exceedsLimit = Array.from(variantTotals.values()).some((quantity) => quantity > limit);
        for (const input of quantities) {
          const ownQuantity = Math.max(0, input.valueAsNumber || 0);
          const variantCapacity = input.dataset.iidVariantCapacity === undefined ? Infinity : Number(input.dataset.iidVariantCapacity);
          const variantRemaining = Math.min(limit, variantCapacity) - variantTotals.get(input.dataset.iidLineVariant) + ownQuantity;
          input.max = String(Math.max(0, variantRemaining));
          input.setCustomValidity(variantTotals.get(input.dataset.iidLineVariant) > limit ? form.dataset.iidOrderLimitMessage : '');
          const lineWarning = input.closest('.iid-cart-line').querySelector('[data-iid-line-order-limit]');
          if (lineWarning) lineWarning.hidden = variantTotals.get(input.dataset.iidLineVariant) <= limit;
          input.closest('[data-iid-quantity]').dispatchEvent(new Event('iid:quantity-limits'));
        }
        if (warning) warning.hidden = !exceedsLimit;
        if (checkout) checkout.disabled = form.dataset.iidHasUnavailable === 'true' || exceedsLimit;
        return !exceedsLimit;
      };
      quantities.forEach((input) => {
        input.addEventListener('input', updateLimits);
        input.addEventListener('change', updateLimits);
      });
      form.addEventListener('submit', (event) => {
        if (!updateLimits() || !form.reportValidity()) event.preventDefault();
      });
      updateLimits();
    });
    root.querySelectorAll('[data-iid-variant-form]').forEach((form) => {
      if (form.dataset.iidReady) return;
      form.dataset.iidReady = 'true';
      const select = form.querySelector('select');
      const submit = form.querySelector('[data-iid-variant-submit]');
      if (!select || !submit) return;
      submit.hidden = true;
      select.addEventListener('change', () => form.requestSubmit());
    });
    root.querySelectorAll('[data-iid-gallery]').forEach((gallery) => {
      if (gallery.dataset.iidReady) return;
      gallery.dataset.iidReady = 'true';
      const main = gallery.querySelector('[data-iid-gallery-main]');
      const image = main?.querySelector('img');
      if (!main || !image) return;
      gallery.querySelectorAll('[data-iid-thumbnail]').forEach((thumbnail) => {
        thumbnail.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          main.href = thumbnail.href;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = thumbnail.href;
          image.alt = thumbnail.querySelector('img')?.alt || image.alt;
          gallery.querySelectorAll('[data-iid-thumbnail]').forEach((item) => item.removeAttribute('aria-current'));
          thumbnail.setAttribute('aria-current', 'true');
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('pageshow', (event) => {
    if (event.persisted && document.querySelector('[data-iid-product], .iid-cart-page')) window.location.reload();
  });
})();


